import { createAction, props } from "@ngrx/store";
import { ShelterSiteModel } from "../../../../../../petszel-shared/src/lib/shared-models/shelter-site.model";

const SET_SHELTER_SITES = 'SET_SHELTER_SITES';
const RESET_SHELTER_SITES = 'RESET_SHELTER_SITES';

export const setShelterSites =
  createAction(SET_SHELTER_SITES, props<{ sites: ShelterSiteModel[] }>());
export const resetShelterSites = createAction(RESET_SHELTER_SITES);
